import React, { useEffect, useState } from "react";
import { ReferenceDetailContactInfo } from "../../interfaces/referenceDetaill";
import { batchSendLetters } from "../../services/reportService";

interface Props {
  references: ReferenceDetailContactInfo[] | null;
  onClose: () => void;
  onSuccess: () => void;
}

const SendBatchLetterModal: React.FC<Props> = ({
  references,
  onClose,
  onSuccess,
}) => {
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [sendLetterIds, setSendLetterIds] = useState<number[]>([]);

  useEffect(() => {
    const fetchReferenceOrderDetails = async () => {
      const batchSendLetterIds =
        references
          ?.filter((ref) => !!ref.includeInSendLetter)
          .map((ref) => ref.referenceDetailID) ?? [];

      setSendLetterIds(batchSendLetterIds);
    };

    fetchReferenceOrderDetails();
  }, []);

  const handleBatchSendLetters = async () => {
    try {
      setLoadingSpinner(true);

      const response = await batchSendLetters(sendLetterIds);
      if (!response) throw new Error("No response from server");
    } catch (error) {
      console.error("Error sending letters:", error);
    } finally {
      setLoadingSpinner(false);
      onClose();
      onSuccess();
    }
  };

  return (
    <>
      {loadingSpinner ? (
        <div className="loading-mask">
          <div className="loading-spinner"></div>
        </div>
      ) : (
        <>
          <div className="background-mask" onClick={onClose}></div>
          <div className="filter-popup">
            <div className="close-button-container">
              <button className="close-button" onClick={onClose}>
                <i className="bi bi-x-circle"></i>
              </button>
            </div>

            <div className="filter-header">
              <h2>Batch Send Letters</h2>
              <div>
                You are about to batch send email letters to all references with
                'Send Letter' selected. An email will also be sent to the
                candidate.
              </div>
              <div className="error">
                Make sure all references have valid emails and that you are
                intending to send them via email, not mail.
              </div>
              <div className="error">
                This operation may take a while depending on how many emails are
                being sent. Please don't disrupt the page while the spinner is
                up.
              </div>
            </div>
            <div className="filter-actions">
              <button
                className={`smbtn btn-green ${
                  sendLetterIds?.length === 0 ? "disabled" : ""
                }`}
                onClick={handleBatchSendLetters}
                disabled={sendLetterIds?.length === 0}
              >
                Send Letters
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default SendBatchLetterModal;
